import React from 'react';
import { Message } from 'primereact/message';
import styles from './accommodation-blocking-violation.module.scss';

interface IAccommodationBlockingViolationProperties {
  violations: string[];
}

function AccommodationBlockingViolation({ violations }: IAccommodationBlockingViolationProperties) {
  if (violations.length === 0) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  return (
    <Message
      severity="error"
      className={styles.message}
      content={
        <ul className={styles.list}>
          {violations.map((violation) => (
            <li key={violation}>{violation}</li>
          ))}
        </ul>
      }
    />
  );
}

export default AccommodationBlockingViolation;
